module.exports = __webpack_public_path__ + "static/media/covid.e1be2506.png";